import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const getters = {
    tagList: state => {
        return state.tagList;
    },

    tag: state => {
        return state.tag;
    },

    tags: state => {
        return state.tags;
    },

    attributes: () => {
        return {
            name: null,
            description: null,
            parent_id: null,
            hidden_tag: false,
            hidden_products: false,
        };
    },
};

const state = {
    lastQuery: null,
    tagList: [],
    tag: getters.attributes(),
    tags: [],
    treeTag: [],
    firstLoad: true,
};

const mutations = {
    [type.SET_TAG_LIST](state, tagList) {
        state.tagList = tagList;
    },

    [type.ADD_TAG](state, tag) {
        state.tagList.push(tag);
    },

    [type.SET_TAG](state, tag) {
        state.tag = tag;
    },

    [type.SET_TAG_ATTRIBUTE](state, { attribute, value } = {}) {
        state.tag[attribute] = value;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    setTag(state, tags) {
        state.tags = tags;
    },

    [type.SET_TREE_TAG](state, tagTree) {
        state.treeTag = tagTree;
    },

    setFlagFirstLoad(state, flag) {
        state.firstLoad = flag;
    },
};

const actions = {
    findTags({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    maxprice: 1,
                },
                params,
            ),
        };

        let tags = state.tagList.filter(t => {
            return params.ids.includes(t.id);
        });

        if (tags.length === params.ids.length) {
            return Promise.resolve(tags);
        }

        startLoading(dispatch, 'find-tags');

        return axios
            .get(Laroute.route('franchise.vue.tags'), options)
            .then(res => {
                endLoading(dispatch, 'find-tags');
                return res.data.data;
            })
            .catch(err => {
                endLoading(dispatch, 'find-tags');
                throw err;
            });
    },

    getTagList({ commit, dispatch }, params = {}) {
        let options = {
            params: _.merge(
                {
                    limit: 300,
                    maxprice: 1,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-tag');

        let api = Laroute.route('franchise.vue.tags');

        return axios
            .get(api, options)
            .then(res => {
                let data = res.data.data;

                commit('setLastQuery', params.query);
                commit(type.SET_TAG_LIST, data);
                endLoading(dispatch, 'fetch-tag');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-tag');
                throw err;
            });
    },

    getTagListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.tagList.length || state.lastQuery !== params.query) {
            return dispatch('getTagList', params);
        }

        return Promise.resolve(state.tagList);
    },

    getParentTagList({ commit, dispatch }, params = {}) {
        let options = {
            params: _.merge(
                {
                    limit: 100,
                    maxprice: 1,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-parent-tag');

        let api = Laroute.route('franchise.vue.parent.tags');

        axios
            .get(api, options)
            .then(res => {
                let data = res.data.data;

                commit('setLastQuery', params.query);
                commit(type.SET_TAG_LIST, data);
                endLoading(dispatch, 'fetch-parent-tag');
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-parent-tag');
                throw err;
            });
    },

    getParentTagListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.tagList.length || state.lastQuery !== params.query) {
            return dispatch('getParentTagList', params);
        }

        return Promise.resolve(state.tagList);
    },

    addTag({ commit }, tag) {
        commit(type.ADD_TAG, tag);
    },

    /**
     * @param {Object} input
     */
    setTagAttribute({ commit }, input) {
        commit(type.SET_TAG_ATTRIBUTE, input);
    },

    createTag({ commit, state, dispatch }) {
        let api = Laroute.route('franchise.inventory.tags.store');
        return axios.post(api, state.tag);
    },

    resetTag({ commit }) {
        commit(type.SET_TAG, getters.attributes());
    },

    setTags({ commit }, input) {
        commit('setTag', input);
    },

    async getTagTree({ commit }, data) {
        let api = Laroute.route('franchise.inventory.tags.tree');
        let id;
        let keyword;
        let params = {};

        if (data !== undefined) {
            params = {
                params: {
                    child: data.id !== undefined ? data.id : null,
                    keyword: data.keyword !== undefined ? data.keyword : null,
                },
            };
        }

        try {
            const response = await axios.get(api, params);

            // if (state.firstLoad || isRequireFirstLoad) {
            commit(type.SET_TREE_TAG, response.data);
            // commit('setFlagFirstLoad', false);
            // }

            return response;
        } catch (err) {
            console.log(err);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
